"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
class Multiselect extends react_1.default.Component {
    debouncedCalculateMoreCount = (0, debounce_1.debounce)(this.calculateMoreCount, 50);
    elementRef = react_1.default.createRef();
    dropdownRef = react_1.default.createRef();
    valuesWrapperRef = react_1.default.createRef();
    valuesRef = new Map();
    showDropdown = false;
    // Holds the number of items that are hidden due to space limits
    moreCount = 0;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            showDropdown: mobx_1.observable,
            moreCount: mobx_1.observable,
            selectedOptions: mobx_1.computed,
        });
    }
    get selectedOptions() {
        return this.props.options.filter(({ value }) => this.props.value.indexOf(value) !== -1);
    }
    componentDidMount() {
        window.addEventListener('resize', this.debouncedCalculateMoreCount, { passive: true });
    }
    componentDidUpdate() {
        this.calculateMoreCount();
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.hideDropdown);
        window.removeEventListener('resize', this.calculateMoreCount);
    }
    render() {
        const { className, disabled, options, placeholder, value } = this.props;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-multiselect', { 'znd-multiselect--disabled': disabled, 'znd-multiselect--open': this.showDropdown }, className), ref: this.elementRef, onClick: this.toggleDropdown },
            react_1.default.createElement("ul", { className: "znd-multiselect__values", ref: this.valuesWrapperRef }, this.selectedOptions.map((option) => {
                if (!this.valuesRef.has(option.value)) {
                    this.valuesRef.set(option.value, react_1.default.createRef());
                }
                return (react_1.default.createElement("li", { key: `${option.value}`, className: "znd-multiselect__value", ref: this.valuesRef.get(option.value) },
                    react_1.default.createElement("span", { className: "znd-multiselect__value-label" }, option.label),
                    react_1.default.createElement("span", { className: "znd-multiselect__value-remove", onClick: (event) => this.onRemove(option.value, event) },
                        react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))));
            })),
            this.moreCount > 0 ? react_1.default.createElement("div", { className: "znd-multiselect__more" },
                "+",
                this.moreCount) : null,
            this.selectedOptions.length === 0 ? (react_1.default.createElement("div", { className: "znd-multiselect__placeholder" }, placeholder)) : null,
            react_1.default.createElement("div", { className: "znd-multiselect__arrow" },
                react_1.default.createElement(Icon_1.default, { name: this.showDropdown ? Zupicons_1.default.angleUp : Zupicons_1.default.angleDown })),
            this.showDropdown ? (react_1.default.createElement("ul", { className: "znd-multiselect__dropdown", ref: this.dropdownRef }, options.map((option) => (react_1.default.createElement("li", { key: `${option.value}`, className: "znd-multiselect__option" },
                react_1.default.createElement("label", { className: "custom-control custom-checkbox znd-multiselect__label" },
                    react_1.default.createElement("input", { type: "checkbox", className: "custom-control-input", checked: value.indexOf(option.value) !== -1, onChange: () => this.onToggle(option.value) }),
                    react_1.default.createElement("span", { className: "custom-control-label" }, option.label))))))) : null));
    }
    onRemove(removedValue, event) {
        event?.preventDefault();
        const newValues = this.props.value.filter((currentValue) => currentValue !== removedValue);
        setTimeout(() => {
            this.props.onChange(newValues);
        });
    }
    onToggle(toggeledValue) {
        const isSelected = this.props.value.indexOf(toggeledValue) !== -1;
        if (isSelected) {
            this.onRemove(toggeledValue);
        }
        else {
            const newValues = [...this.props.value, toggeledValue];
            setTimeout(() => {
                this.props.onChange(newValues);
            });
        }
    }
    toggleDropdown(event) {
        if (this.dropdownRef.current?.contains(event.target) || event.defaultPrevented) {
            return;
        }
        this.showDropdown = !this.showDropdown;
        if (this.showDropdown) {
            document.addEventListener('click', this.hideDropdown);
        }
    }
    hideDropdown(event) {
        if (!this.elementRef.current || this.elementRef.current.contains(event.target)) {
            return;
        }
        this.showDropdown = false;
        document.removeEventListener('click', this.hideDropdown);
    }
    calculateMoreCount() {
        if (!this.valuesWrapperRef.current) {
            return;
        }
        const listRect = this.valuesWrapperRef.current.getBoundingClientRect();
        const hiddenBelow = listRect.top + listRect.height;
        this.moreCount = [...this.valuesRef.values()]
            .map((ref) => ref.current)
            .filter((element) => !!element)
            .map((element) => element.getBoundingClientRect())
            .filter(({ top }) => top >= hiddenBelow).length;
    }
}
__decorate([
    bind_decorator_1.default
], Multiselect.prototype, "onRemove", null);
__decorate([
    bind_decorator_1.default
], Multiselect.prototype, "onToggle", null);
__decorate([
    bind_decorator_1.default
], Multiselect.prototype, "toggleDropdown", null);
__decorate([
    bind_decorator_1.default
], Multiselect.prototype, "hideDropdown", null);
__decorate([
    bind_decorator_1.default
], Multiselect.prototype, "calculateMoreCount", null);
exports.default = (0, mobx_react_1.observer)(Multiselect);
